const Resources = {
  "car": require('./car.jpg'),
  "x_ray": require('./x-ray.jpeg')
};

export default Resources;
